import { useEffect, useState } from 'react';
import { API_URL } from '../../config';

// Tarifs des agents IA, lus sur le serveur (Admin -> Offres des agents IA -> Tarifs) : une seule source pour les presentations et la page d'accueil.
let cache = null;
let pending = null;

export const fmtArPrice = (n) => `${Math.round(n || 0).toLocaleString('fr-FR')} Ar`.replace(/[\u00a0\u202f]/g, ' ');

export function loadAgentPrices() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = fetch(`${API_URL}/api/agent-offers/prices`)
      .then(r => r.json())
      .then(d => { if (d.success) cache = d.prices; return cache; })
      .catch(() => null)
      .finally(() => { pending = null; });
  }
  return pending;
}

export default function useAgentPrices() {
  const [prices, setPrices] = useState(cache);
  useEffect(() => { let alive = true; loadAgentPrices().then(p => { if (alive && p) setPrices(p); }); return () => { alive = false; }; }, []);
  return prices;
}
